import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { ResultSection } from '../common/sections/ResultSection';
import { BottomNavigationBox } from '../common/BottomNavigationBox';
import { PageHeader } from '../common/PageHeader';
import BrandUtils from '../../utils/BrandUtils';
import BrowserUtils from '../../utils/BrowserUtils';
import SessionStore from '../../stores/SessionStore';

/**
 * @todo
 * The quality of this component could be improved if future improvement work is
 * undertaken.
 */
class AccountLockedPage extends Component {
  constructor(props) {
    super(props);

    this.onSubmitHandler = this.onSubmitHandler.bind(this);

    this.state = {
      errorQuoteId: SessionStore.getAccountLockedQuoteID(),
    };
  }

  componentWillMount() {
    BrowserUtils.setViewPort(1);
  }

  onSubmitHandler() {
    window.open(`${this.props.content.bankWebsite}/bpassword`, '_blank');
  }

  render() {
    let explanation4 = this.props.content.accountLockedPageExplanation4;
    explanation4 = explanation4.replace('{quote_id}', this.state.errorQuoteId);
    return (
      <div className="internet-banking result-page-wrapper contact-bank-page-wrapper-bapp container-fluid">
        <Helmet title={this.props.content.accountLockedPageHeader} />
        <PageHeader
          visible={BrandUtils.isAbleToDisplay('result-pages-header')}
          title={this.props.content.landingPageTitle}
          content={this.props.content}
        />

        <div className="result-page white-board contact-bank-page" role="main">
          <div className="row text-center">
            <div className="col-xs-12">
              <ResultSection
                imgSrc={BrandUtils.getResultImage(
                  'account-opened-page-with-image',
                  'sorry-illustration.png'
                )}
                imgAlt="Contact Bank"
                title={this.props.content.accountLockedPageHeader}
              >
                <p>{this.props.content.accountLockedPageExplanation1}</p>
                <p>{this.props.content.accountLockedPageExplanation2}</p>
                <p>
                  <BottomNavigationBox
                    onClickNext={this.onSubmitHandler}
                    className="col-xs-12 text-center"
                    nextButtonLabel={
                      this.props.content
                        .accountLockedPageResetPasswordButtonLabel
                    }
                  />
                </p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: this.props.content.accountLockedPageExplanation3,
                  }}
                />
                <p dangerouslySetInnerHTML={{ __html: explanation4 }} />
              </ResultSection>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AccountLockedPage.propTypes = {
  data: PropTypes.object,
  validations: PropTypes.object,
  content: PropTypes.object,
};

export { AccountLockedPage };
